import * as React from 'react';

const UrlParams = ({ query }: { query: string }) => {
	React.useEffect(() => {
		window.history.replaceState(null, '', `?${query}`);
	}, [query]);

	return null;
};

export default React.memo(UrlParams);
